// Detectar la moneda de la tienda actual
function getStoreCurrency() {
  return window.Shopify?.currency?.active || 'USD';
}

// Formatear precio con la moneda correcta
function formatMoney(cents, currency) {
  const amount = (cents / 100).toFixed(2);
  
  const locale = {
    'GTQ': 'es-GT',
    'HNL': 'es-HN',
    'NIO': 'es-NI',
    'CRC': 'es-CR',
    'USD': 'es-SV',
    'PAB': 'es-PA',
  }[currency] || 'es-419';
  
  return new Intl.NumberFormat(locale, {
    style: 'currency',
    currency: currency === 'PAB' ? 'USD' : currency // Panamá usa USD en la práctica
  }).format(cents / 100);
}

